import axios from 'axios'
import React, { useState } from 'react'
import ButtonsSystem from '../../../../../../../../buttonsSystem/ButtonsSystem'
import FormsSystem from '../../../../../../../../formsSystem/FormsSystem'
import TitleHeader from '../../../../../../../../smallComponents/Header'
import TextEngineToolsFooter from '../../../../../../../../smallComponents/TextEngineToolsFooter'
import FormImagesUploader from '../../../../../../../../uploadImageSystem/FormImagesUploader'
import NewAppFormConfigs from './NewAppFormConfigs'
import { useTranslation } from 'react-i18next'
import FormDataInitialValueExtractor from '../../../../../../../../formsSystem/FormDataInitialValueExtractor'
import FormDataLangModulator from '../../../../../../../../formsSystem/FormDataLangModulator'
import FullFormChecker from '../../../../../../../../formsSystem/FullFormChecker'
import i18next from 'i18next'

const NewResearchApplicationForm = ({
  DCGProps,
  setProjectResearchApps,
  GeneralDialogClose,
  activity,
  setResActApps,
}) => {
  const { project, isDarkModeActive } = DCGProps
  const [images, setImages] = useState([])
  const { t } = useTranslation()
  // order matters
  const [formData, setFormData] = useState({}) //1
  const newformData = FormDataLangModulator(formData, t) //2
  FormDataInitialValueExtractor(NewAppFormConfigs(), setFormData) //3
  const [chosenHashTagElements, setChosenHashTagElements] = useState([])
  const lang = i18next.language
  const rtl = lang === 'ar'
  const [isCreating, setIsCreating] = useState(false)
  const buttonsArray = [
    {
      title: rtl ? 'إلغاء' : 'Cancel',
      funs: () => {
        GeneralDialogClose()
      },
    },
    {
      title: rtl
        ? isCreating
          ? 'جارى الإنشاء'
          : 'إنشاء'
        : isCreating
        ? 'Creating...'
        : 'Create',
      disabled:
        !FullFormChecker({
          FormConfig: NewAppFormConfigs(),
          formData,
        }) || isCreating,
      funs: async () => {
        setIsCreating(true)
        try {
          const res = await axios.post(`/researchApps`, {
            ...newformData,
            projectId: project._id,
            researchActivityId: activity?._id,
            images,
            chosenHashTagElements,
          })
          if (typeof setResActApps === 'function')
            setResActApps((cons) => [...cons, res.data.researchapp])
          if (setProjectResearchApps)
            setProjectResearchApps((cons) => [...cons, res.data.researchapp])
          setIsCreating(false)
          GeneralDialogClose()
        } catch (error) {
          console.log(error)
        }
      },
    },
  ]
  return (
    <div style={{ color: isDarkModeActive && 'white' }}>
      <FormImagesUploader images={images} setImages={setImages} />
      <TitleHeader
        headerText={rtl ? 'تفاصيل التطبيق' : 'Applications Details'}
      />
      <FormsSystem
        {...DCGProps}
        formComponentsArray={NewAppFormConfigs()}
        formComponentsValues={formData}
        setFormComponentsValues={setFormData}
        setChosenHashTagElements={setChosenHashTagElements}
        chosenHashTagElements={chosenHashTagElements}
      />
      <ButtonsSystem buttonsArray={buttonsArray} />
      <TextEngineToolsFooter {...DCGProps} />
    </div>
  )
}

export default NewResearchApplicationForm
